import { Select, Spin } from "antd";
import { useEffect, useState } from "react";
import FileUpload from "themes/elements/FileUpload";
import SelectComp from "themes/elements/Select";
import style from "../../create_article.module.scss";

function LeftSection({
  isEdit,
  selectedArticle,
  counsilor,
  setCounsilor,
  setNewsImage,
  newsImage,
  handleImageUpdate,
  counsilorData,
  loading,
  setSearchInput,
}) {
  const [localOptions, setLocalOptions] = useState([]);
  const [preloadingCouncillor, setPreloadingCouncillor] = useState(false);

  useEffect(() => {
    setLocalOptions(counsilorData || []);

    const { key, label } = counsilor?.counsilor_data || {};
    const id = selectedArticle?.councilor_id;

    const shouldFetchLabel =
      isEdit && id && key && !label && Array.isArray(counsilorData);

    if (shouldFetchLabel) {
      setPreloadingCouncillor(true);

      const match = counsilorData.find((c) => c.key === id);

      if (match) {
        setCounsilor((prev) => {
          const updated = {
            ...prev,
            counsilor_data: {
              key: match.key,
              label: match.label,
            },
            ward_data: match.ward_code,
          };

          return updated;
        });
      } else {
      }

      setPreloadingCouncillor(false);
    }
  }, [counsilorData]);

  const handleChange = (field, value) => {
    setCounsilor((prev) => ({ ...prev, [field]: value }));
  };

  const handleSelectChange = (value, option) => {
    const selectedCouncillor = localOptions.find((c) => c.key === value);
    handleChange("counsilor_data", {
      key: value,
      label: option?.label || option?.children || "",
    });
    handleChange("ward_data", selectedCouncillor?.ward_code || null);
  };

  return (
    <div className={`flex flex-column gap-5 ${style["left-section"]}`}>
      <div className="flex flex-column">
        <label className="input-label mb-2">Councillor</label>

        {(isEdit && preloadingCouncillor) ||
        (isEdit && !counsilor?.counsilor_data?.label) ? (
          <Spin className="py-3" tip="Loading councillor..." />
        ) : (
          <Select
            showSearch
            labelInValue
            loading={loading}
            notFoundContent={
              loading ? <Spin size="small" /> : "No councillor found"
            }
            className="chip-select-search color-select"
            style={{ width: "100%" }}
            popupClassName="select-popover color-select-popover"
            value={
              counsilor?.counsilor_data?.key && counsilor?.counsilor_data?.label
                ? {
                    value: counsilor.counsilor_data.key,
                    label: counsilor.counsilor_data.label,
                  }
                : undefined
            }
            onSearch={setSearchInput}
            onChange={(valueObj) =>
              handleSelectChange(valueObj.value, valueObj)
            }
            filterOption={(input, option) =>
              option.children.toLowerCase().includes(input.toLowerCase())
            }
            placeholder="Select a councillor"
          >
            {localOptions.map((c) => (
              <Select.Option key={c.key} value={c.key}>
                {c.label}
              </Select.Option>
            ))}
          </Select>
        )}
      </div>

      {counsilor?.ward_data &&
        counsilor?.counsilor_data?.label &&
        !preloadingCouncillor && (
          <div className="mt-4 mb-2">
            <SelectComp
              data={[
                {
                  label: counsilor.ward_data,
                  value: counsilor.ward_data,
                },
              ]}
              onChange={() => {}}
              label="Ward"
              value={counsilor.ward_data}
              disabled
              allowClear={false}
            />
          </div>
        )}

      <div className="flex flex-column gap-2">
        <label className="input-label">Image/Thumbnail</label>
        <FileUpload
          deleteModalOpen={isEdit && selectedArticle?.councilor_image_filepath}
          previewImage={newsImage}
          type="news"
          handleImageUpdate={handleImageUpdate}
          defaultFileList={
            isEdit && selectedArticle?.images?.[0]?.project_image
              ? [
                  {
                    uid: "-1",
                    name: "Thumbnail image",
                    url: selectedArticle.images[0].project_image,
                  },
                ]
              : []
          }
          setPreviewImage={setNewsImage}
          title="Upload article image"
        />
      </div>
    </div>
  );
}

export default LeftSection;
